require('./bootstrap');

import Alpine from 'alpinejs';

// Make Alpine available globally (optional, but often useful for plugins or debugging)
window.Alpine = Alpine;

// Start Alpine.js
Alpine.start();

import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css'; // optional for styling
tippy('[data-tippy-content]');
